import { date } from '@crehana/utils';
import moment from 'moment';

export const fmtDatesToForm = (dateString: string) => {
  const { startDate, endDate, activityEndDate, activityStartDate } =
    JSON.parse(dateString);
  if (activityStartDate && activityEndDate) {
    return {
      startDate: date.format(activityStartDate, 'DD-MM-YYYY', 'YYYY-MM-DD'),
      endDate: date.format(activityEndDate, 'DD-MM-YYYY', 'YYYY-MM-DD'),
    };
  }
  return {
    startDate: startDate
      ? date.format(startDate, 'DD/MM/YYYY', 'YYYY-MM-DD')
      : null,
    endDate: endDate ? date.format(endDate, 'DD/MM/YYYY', 'YYYY-MM-DD') : null,
  };
};

export const dateStrToMoment = (dateStr?: string, diff?: '+1' | '-1') => {
  const today = moment(new Date());
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (dateStr === '') return today;
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!dateStr) return;

  const parts = dateStr.split('/');
  const date = new Date(
    parseInt(parts[2], 10),
    parseInt(parts[1], 10),
    parseInt(parts[0], 10),
  );

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (diff === '+1') return moment(date).add(1, 'day').subtract(1, 'M');
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (diff === '-1') return moment(date).subtract(1, 'day').subtract(1, 'M');
  return moment(date).subtract(1, 'M');
};

export const fmtDatesToQuery = ({
  startDate,
  endDate,
}: {
  startDate: string | null;
  endDate: string | null;
}) => {
  return {
    start_date: startDate
      ? date.format(startDate, 'YYYY-MM-DD', 'DD-MM-YYYY')
      : null,
    end_date: endDate ? date.format(endDate, 'YYYY-MM-DD', 'DD-MM-YYYY') : null,
  };
};
